loadjs.ready(['jquery', 'core'], function() {
    var $vouchersModalForm = $('#checkout-vouchers-modal form');
    var voucherItem = $('#voucher-list-item-tpl').html();
    var $voucherList = $vouchersModalForm.find('.list');

    $vouchersModalForm
        .on('click', 'a.list-item', function(e) {
            var $el = $(this);
            e.preventDefault();

            preloader(1);
            $.ajax({
                url: $vouchersModalForm.attr('action'),
                type: 'DELETE',
                data: {voucher: $el.data('code'), id: $el.data('id')},
                success: function(response) {
                    if (response.success) {
                        $el.remove();
                        $vouchersModalForm.trigger('voucher:removed');
                    }
                    preloader(0);
                }
            });
        })
        .on('success', function(e, response) {
            var $input = $vouchersModalForm.find('input')
            var $inputItem = $input.closest('.list-item');
            var $vouchers = $voucherList.find('.list-item').not($inputItem);

            response.vouchers.forEach(function (voucher) {
                var $voucher = $vouchers.filter('[data-id="' + voucher.id + '"]');
                if (!$voucher.length) {
                    $voucher = $(
                        voucherItem
                            .replace('{id}', voucher.id)
                            .replace('{shop}', voucher.shop)
                            .replace(/{code}/g, voucher.code)
                    );
                    $voucher.insertBefore($inputItem);
                }
                $input.val('');
            })

            $vouchersModalForm.trigger('voucher:added');
        })
})